export class History {
  _updatingFromOutside = true;

  constructor(historyEngine) {
    this._historyEngine = historyEngine;
    this._historyEngine.listen(this._historyChanged);
  }
  /* 
    Sets handler to be called when URL changes (as a result of navigating a link, 
      editing address bar, going back, going forward or setting window.location... directly)
  */
  setOnChange(onChange) {
    this._onChange = onChange;
  }

  /*
    PUSH new path. Will NOT call onChangeHandler
  */
  push(path) {
    try {
      this._updatingFromOutside = false;
      this._historyEngine.push(path);
    }
    finally {
      this._updatingFromOutside = true;
    }
  }

  /*
    REPLACE new path. Will NOT call onChangeHandler
  */
  replace(path) {
    try {
      this._updatingFromOutside = false;
      this._historyEngine.replace(path);
    }
    finally {
      this._updatingFromOutside = true;
    }
  }

  _historyChanged = (location, action) => {
    if(true || this._updatingFromOutside) {
      this._onChange && this._onChange(location, action);
    }
  }

  get location() {
    return this._historyEngine.location;
  }

  get action() {
    return this._historyEngine.action;
  }

}


// WEBPACK FOOTER //
// ./src/model/History.js